import React, { useEffect, useState } from 'react';

import {
  ButtonWrapper,
  GroupOverlayCenter,
  GroupOverlayInner,
  LabelWrapper,
  SVGWrapper,
  Table,
  Td,
  Th,
  Thead,
  Tr
} from '../managedITServices/components/css';
import CancelSVG from '../managedITServices/assets/svg/cancel';
import SaveSVG from '../managedITServices/assets/svg/save';
import EditSVG from '../managedITServices/assets/svg/edit';
import CategoryOption from './categoryOption';
import {
  changeQuestion,
  deleteQuestion,
  saveQuestion
} from '../managedITServices/components/saveSchemaToDB';
import ValidateLoader from '../../../UI/validateLoader';
import { Title } from '../../css';

const Category = ({
  microsoftLicensingAdminData,
  setMicrosoftLicensingAdminData,
  setCategorySelected,
  editMode,
  setEditMode,
  offeringId,
  serviceId
}) => {
  const [initialData, setInitialData] = useState([]);
  const [dataSaved,setDataSaved] = useState(false);
  const [deleteCategories,setDeleteCategories] = useState([]);
  const [isLoading,setIsLoading] = useState(false);
  
  // Saving initial microsoftLicensingAdminData
  useEffect(() => {
    const clonedAdminData = JSON.parse(
      JSON.stringify(microsoftLicensingAdminData)
    );
    setInitialData(clonedAdminData);
    setDataSaved(false);
  }, [dataSaved]);
  const categoryListValid = () =>
    microsoftLicensingAdminData.every(item => item.name); // name refers to categoryName here

  const handleDeleteCategories = async  () => {
    deleteCategories.forEach(async (categoryId)=>{
    if(categoryId)
        {
            await deleteQuestion(categoryId);
        }

    });
   
  };

  const handleSave = async () => {
    if(deleteCategories.length !==0)
    {
        await handleDeleteCategories();
    }
    const clonedAdminData = JSON.parse(
      JSON.stringify(microsoftLicensingAdminData)
    );

    if (categoryListValid()) {
      try {
        setIsLoading(true);
        const savedQuestionPromises = clonedAdminData.map(
          async (question, index) => {
            const { name, id } = question;

            if (id) {
              // Update the existing question
              await changeQuestion(id, {
                name,
                ord:index,
                id
              });
            } else {
              // Save new question
              const newSavedQuestionId = await saveQuestion({
                serviceId,
                offeringId,
                ord:index,
                name
              });
              clonedAdminData[index].id = newSavedQuestionId; // Add the newly saved ID to the cloned admin data
              clonedAdminData[index].ord = index; 
            }
          }
        );
        // Wait for all questions to be saved or updated
        await Promise.all(savedQuestionPromises);
        console.log('All Questions Saved Successfully');
        setMicrosoftLicensingAdminData(clonedAdminData);
        setDataSaved(true);
        // Toggle edit mode only after save is successful
        setEditMode(false);
      } catch (error) {
        console.error('Error while saving questions:', error);
        alert("An Error occurred, Please try again");
        setIsLoading(false);
      }
      finally{
        setIsLoading(false);
      }
    }
  };

  const handleCancel = () => {
    const clonedAdminData = JSON.parse(JSON.stringify(initialData));
    setDeleteCategories([]);
    const filteredData = clonedAdminData.filter(category=>category.id && category.name);
    setMicrosoftLicensingAdminData(filteredData);
    setEditMode(false);
  };

  useEffect(() => {
    if (editMode) setCategorySelected('');
  }, [editMode]);

  useEffect(() => {
    if (microsoftLicensingAdminData.length === 0) {
      const clonedAdminData = JSON.parse(
        JSON.stringify(microsoftLicensingAdminData)
      );
      clonedAdminData.push({
        id: '',
        name: '',
        productCatalogOptions: [
          {
            questionId: '',
            id: '',
            name: '',
            productCatalogPricings: [
              {
                optionId: '',
                id: '',
                cost: 0,
                onetimePrice: 0,
                costPremium: 0,
                onetimePricePremium: 0,
                operationType: 'ADD'
              }
            ]
          }
        ]
      });
      setMicrosoftLicensingAdminData(clonedAdminData);
    }
  }, [microsoftLicensingAdminData]);

  return (
    <>
     {isLoading && (
        <GroupOverlayCenter>
          <GroupOverlayInner>
            {/* Please wait request is In progress.... */}
            <ValidateLoader
                message="Please wait request is In progress...."
                isFormStep={isLoading}
            />
          </GroupOverlayInner>
        </GroupOverlayCenter>
      )}
      <Tr>
        <Td background="#f7f7f7">
          <LabelWrapper>
            <span>Category</span>
            <ButtonWrapper>
              {editMode ? (
                <>
                  <SVGWrapper onClick={handleCancel}>
                    <CancelSVG />
                  </SVGWrapper>
                  <SVGWrapper onClick={handleSave}>
                    <SaveSVG />
                  </SVGWrapper>
                </>
              ) : (
                <>
                  <SVGWrapper onClick={() => setEditMode(!editMode)}>
                    <EditSVG />
                  </SVGWrapper>
                </>
              )}
            </ButtonWrapper>
          </LabelWrapper>
        </Td>
        {/* <Td> */}
          {editMode ? (
            <CategoryOption
            key={microsoftLicensingAdminData[0].id}
              microsoftLicensingAdminData={microsoftLicensingAdminData}
              setMicrosoftLicensingAdminData={setMicrosoftLicensingAdminData}
              categoryName={microsoftLicensingAdminData[0].name}
              categoryIndex={0}
              isLast={microsoftLicensingAdminData.length === 1}
              isFirst={true}
              initialData={initialData}
              setInitialData={setInitialData}
              deleteCategories={deleteCategories}
              setDeleteCategories={setDeleteCategories}
            />
          ) : (
           <Td>
            <select
              name="category"
              id="category"
              onChange={e => setCategorySelected(e.target.value)}
            >
              <option value="">Select Category</option>
              {microsoftLicensingAdminData.map((categoryItem, index) => (
                <option key={categoryItem.id} value={index}>
                  {categoryItem.name}
                </option>
              ))}
            </select>
            </Td>
          )}
        {/* </Td> */}
        {/* <Td></Td>
        <Td></Td> */}
      </Tr>
      {editMode && (
        <>
          {microsoftLicensingAdminData
            .slice(1)
            .map((categoryItem, categoryIndex) => (
              <CategoryOption
                key={categoryItem.id}
                microsoftLicensingAdminData={microsoftLicensingAdminData}
                setMicrosoftLicensingAdminData={setMicrosoftLicensingAdminData}
                categoryName={categoryItem.name}
                categoryIndex={categoryIndex + 1}
                isLast={
                  categoryIndex === microsoftLicensingAdminData.length - 2
                }
                isFirst={false}
                initialData={initialData}
              setInitialData={setInitialData}
              deleteCategories={deleteCategories}
              setDeleteCategories={setDeleteCategories}
              />
            ))}
        </>
      )}
    </>
  );
};

export default Category;
